import {
  borderRadius,
  customScrollMinimal,
  Drawer,
  Modal,
  typographyV2,
} from '@toggle/design-system';
import styled from 'styled-components';

import { ChatInputComposer } from '~/components/chat';

export const Title = styled.div`
  ${typographyV2.titleMd}
  color: var(--text-default);
  margin-bottom: 8px;
`;

export const Root = styled.div`
  width: 100%;
  height: auto;
  border: 1px solid var(--border-soft);
  ${borderRadius.r2}
`;

export const StyledDrawer = styled(Drawer)`
  [data-drawer-body] {
    overflow: hidden;
  }

  [data-drawer-container] {
    width: 90vw;
  }
`;

export const DrawerSectionWrapper = styled.div`
  display: flex;
  overflow: hidden;
  height: 100%;
`;

export const CitationsHeaderTitle = styled.h2`
  ${typographyV2.titleMd}
`;

export const DrawerSection = styled.div`
  width: 50%;
  height: 100%;
  display: flex;
  flex-direction: column;

  &:first-child {
    padding: 20px;
    border-right: 1px solid var(--border-soft);
    overflow: scroll;
    ${customScrollMinimal};
  }

  &:last-child {
    display: inline-grid;
    padding: 12px;
    height: 100%;
  }
`;

export const DocumentChatModal = styled(Modal)`
  [data-modal-container] {
    width: 674px;
    border-radius: 8px;
    border: 1px solid var(--border-soft);
    background: var(--background-soft);
    padding-bottom: 0;
  }

  [data-modal-header] {
    padding: 6px 6px 20px 20px;

    [data-modal-text-container] {
      margin: 18px 0 0 0;
    }
  }

  [data-modal-title] {
    margin-bottom: 24px;
  }

  [data-modal-description] {
    margin-top: 12px;
  }

  ${ChatInputComposer.Styled.Form} {
    width: 100%;
  }
`;
